module.exports = __webpack_public_path__ + "static/iaa-7255523261d11b239f409aadbc18653c.svg";